import { Group, LoadsState, Position, RotateOptions } from 'src/app/core/types';
import { LoadGroup } from './group';
import { loadsPerAxisForDrawing } from './loads-per-axis.helper';

/** Maps session groups to draw groups, including each pallet cube's own contents. */
export function sessionGroupsToLoadGroups(groups: Group[]): LoadGroup[] {
  return groups.flatMap((group) => sessionGroupToLoadGroups(group));
}

function sessionGroupToLoadGroups(group: Group): LoadGroup[] {
  return (group.loadsCubes ?? []).flatMap((loadCube) => {
    if (loadCube.position == null || !(loadCube.dimensions ?? group.dimensions)) {
      return [];
    }
    const cubeContents = loadCube.palletContentGroups;
    const overlayGroups = cubeContents ?? group.palletContentGroups;
    const contentLoadGroups = overlayGroups?.length
      ? overlayGroups.flatMap((contentGroup) => sessionGroupToLoadGroups(contentGroup))
      : undefined;
    const loadPosition: Position = {
      x: loadCube.position.x,
      y: loadCube.position.y,
      z: loadCube.position.z,
    };
    const loadProperties: LoadsState = {
      rotated: loadCube.state?.rotated ?? false,
      flipped: loadCube.state?.flipped ?? false,
      dragged: loadCube.state?.dragged ?? false,
      stacking: loadCube.stacking !== undefined ? loadCube.stacking : group.stacking,
    };
    const maxLoadsOnTop: number | string = group.stackingOptions
      ? group.stackingOptions.maxLoadsOnTop
      : undefined;
    const pctSupport: number = group.stackingOptions ? group.stackingOptions.pctSupport : undefined;
    const stackingOptions = {
      ...(group.stackingOptions ?? {}),
      ...(loadCube.stackingOptions ?? {}),
    };
    const rotateOptions: RotateOptions = {
      allowToRotate: group.allowToRotate,
      rotateFreely: group.rotateFreely,
      rotateOnBase: group.rotateOnBase,
    };
    const loadGroup: LoadGroup = new LoadGroup(
      group.id,
      group.loadType,
      loadCube.color ?? group.color,
      group.name,
      group.createdAt,
      group.quantity,
      group.weight,
      loadCube.yRotation ?? 0,
      loadCube.edgeRotation ?? 0,
      group.dimensions,
      loadPosition,
      loadCube.dimensions ? loadCube.dimensions : group.dimensions,
      loadsPerAxisForDrawing(loadCube, group.loadsCubes, group.dimensions),
      loadProperties,
      group.packed,
      maxLoadsOnTop,
      group.nameTranslated,
      group.showLoadName,
      loadCube.centerOfMass ? loadCube.centerOfMass : group.centerOfMass,
      rotateOptions,
      group.allowOutOfSpace,
      pctSupport,
      stackingOptions,
    );
    loadGroup.times100();
    if (contentLoadGroups?.length) {
      loadGroup.palletContentLoadGroups = contentLoadGroups;
    }
    return [loadGroup];
  });
}
